import WindowManager from './core/Manager';

export default WindowManager;
